import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import DocumentoAuxiliarItem from '../../../../../components/DocumentoAuxiliarItem/DocumentoAuxiliarItem';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import ArrowDownwardIcon from '../../../../../components/Icons/ArrowDownwardIcon';
import { Row } from '../../../../../components/Row';
import { HelpButton } from '../../../../../components/HelpButton';
import { CONTRATO_TIPO_ENTE_PUBLICO } from '../../../../../library/ContratoTipos';
import { loadContratoArquivosAuxiliares } from '../../../../../store/modules/ContratosActions';
import { getElementID } from '../../../../../utils/HTMLUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DownloadChecklists.scss';
import SnackbarUtils from 'utils/SnackbarUtils';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-download-checklists';

const INITIAL_STATE = {
  notFound: false,
  files: [],
};

class DownloadChecklists extends GenericContent {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  getActions = () => {
    return (
      <>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          ></Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.getStartButtonLabel()}
              theme='pufvYellow'
              onClick={this.toStart}
              rightIcon={<ArrowDownwardIcon />}
            />
          </Col>
        </Row>
      </>
    );
  };

  getStartButtonLabel = () => {
    return this.props.utils.editing()
      ? this.props.languageValues.continuarContratacaoLabel
      : this.props.languageValues.iniciarContratacaoLabel;
  };

  toStart = () => {
    this.props.toEtapaDados();
  };

  reset() {
    this.setState(INITIAL_STATE);
  }

  componentWillUnmount() {
    this.reset();
  }

  loadArquivos = () => {
    this.props.loadContratoArquivosAuxiliares(
      CONTRATO_TIPO_ENTE_PUBLICO,
      () => {
        this.setState(
          {
            files: this.props.contratos.arquivosAuxiliaresList,
          },
          () => {
            if (this.state.files.length === 0) {
              this.setState({
                notFound: true,
              });
            }
          }
        );
      },
      (error) => {
        SnackbarUtils.enqueueSnackbar({
          message:
            error.response.statusText ||
            this.props.languageValues.errorLoadContratoDocumentosAuxiliares,
          options: {
            variant: 'error',
          },
        });
      }
    );
  };

  componentDidMount() {
    this.loadArquivos();
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDownloadChecklists}{' '}
            <HelpButton
              text={this.props.languageValues.checklistToltip}
              className={rootClassName + '-title-hint'}
            />
          </CardTitle>
        ),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.props.contratos.loadingArquivosAuxiliaresList,
      },
    };
  };

  getFiles = () => {
    if (this.state.files.length === 0) {
      return this.state.notFound ? (
        <div className={rootClassName + '-not-found'}>
          {this.props.languageValues.notFoundChecklistFiles}
        </div>
      ) : null;
    }
    return this.state.files.map((file, fileIndex) => {
      return (
        <Col cols={[12, 6, 4, 3, 3]} key={fileIndex}>
          <DocumentoAuxiliarItem
            {...file}
            index={fileIndex}
            elementId={getElementID(rootElementId, 'file')}
          />
        </Col>
      );
    });
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <Row>
          {this.props.contratos.loadingArquivosAuxiliaresList
            ? null
            : this.getFiles()}
        </Row>
      </GenericCardScreen>
    );
  }
}

DownloadChecklists.propTypes = {
  toEtapaDados: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadContratoArquivosAuxiliares,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DownloadChecklists));
